




















































import Vue from 'vue';
import Component from 'vue-class-component';
import SectionLayout from '@/components/SectionLayout.vue';
import LeagueCard from '@/components/home/HomeLeague/HomeLeagueCard.vue';
import NavBar from '@/components/NavBar';
import {authModule, impactBoardMembersModule} from '@/utils/store-acessor';
import {featureKey as impactBoardFeatureKey} from '@/store/impact-board-members.store.module';
import {ImpactBoardMemberModel} from '@/models/impact-board-member.model';
import {Getter} from 'vuex-class';

@Component({
  components: {
    SectionLayout,
    LeagueCard,
    NavBar
  },
  metaInfo() {
    return {
      title: 'Ikone'
    };
  },
})
export default class HomeLeague extends Vue {
  @authModule.Getter('isAuthenticated') readonly isAuthenticated!: boolean;
  @impactBoardMembersModule.Getter('loading') loading!: boolean;
  @impactBoardMembersModule.Getter('allMembers') members!: ImpactBoardMemberModel[];

  showTheLeague() {
    this.$router.push('the-league');
  }
}
